<div class="d-flex align-items-center gap-2 mb-3">
  <i [class]="icon + ' fa-solid text-warning'"></i>
  <span class="fw-bold">{{ title | translate }}:</span>
</div>
